/* istanbul ignore file */
import {AspectRatioCard} from '@homeaway/react-aspect-ratio-card';
import edap from '../edap';
import determineIfMobile from '@homeaway/react-determine-if-mobile';
import ListingMapCarousel from './listing-map-carousel';
import ListingPrice from './listing-price';
import ListingRooms from './listing-rooms';
import ListingUrl from './listing-url';
import ListingCollaboration from './listing-collaboration';
import React, {Component} from 'react';
import './listing-hit.less';

export const ASPECT_RATIO_4X3 = '4x3';

export class ListingHit extends Component {

    constructor(props) {
        super(props);
        this.state = {
            carouselIndex: 0
        };
    }

    handleHitClick = () => {
        const {boardId, unitUuid, images} = this.props;
        const imageCount = images.length;
        edap.mapPropertyClicked(boardId, this.state.carouselIndex, imageCount, unitUuid);
    }

    updateCarouselState = (index) => {
        this.setState({carouselIndex: index});
    }

    render() {
        const {
            aspectRatio = ASPECT_RATIO_4X3,
            averagePrice,
            bathrooms,
            bedrooms,
            className,
            showCollaborationToolbar = false,
            detailPageUrl,
            edapEventJson,
            images,
            isMobile,
            priceSummary,
            sleeps,
            status,
            stay
        } = this.props;

        const target = isMobile ? '_self' : '_blank';

        return (
            <div className={`listing-hit ${className || ''}`}>
                <AspectRatioCard aspectRatio={aspectRatio} hasHover={false} hasHoverOverlay={false} >
                    <ListingMapCarousel
                        data-slot={'figure'}
                        detailPageUrl={detailPageUrl}
                        images={images}
                        onClick={this.handleHitClick}
                        stay={stay}
                        target={target}
                        isMobile={isMobile}
                        updateCarouselState={this.updateCarouselState}
                    />
                    <ListingUrl
                        data-slot={'caption'}
                        detailPageUrl={detailPageUrl}
                        onClick={this.handleHitClick}
                        stay={stay}
                        target={target}
                    >
                        <ListingRooms
                            bathrooms={bathrooms}
                            bedrooms={bedrooms}
                            className="AspectRatioCardTitle h4 text-bold text-ha-gray-dark"
                            sleeps={sleeps}
                        />
                    </ListingUrl>
                    <div data-slot={'content'}>
                        <ListingUrl
                            detailPageUrl={detailPageUrl}
                            onClick={this.handleHitClick}
                            stay={stay}
                            target={target}
                        >
                            <ListingPrice
                                averagePrice={averagePrice}
                                edapEventJson={edapEventJson}
                                priceSummary={priceSummary}
                                stay={stay}
                                status={status}
                            />
                        </ListingUrl>
                        {showCollaborationToolbar && <ListingCollaboration {...this.props} />}
                    </div>
                </AspectRatioCard>
            </div>
        );
    }
}

export default determineIfMobile(ListingHit);



// WEBPACK FOOTER //
// ./src/universal/tripboard/listing/listing-hit.js